const PROPERTY_NAME = /^properties\[(.+)\]$/;

/**
 * RAZ-420: a product form's line item properties, read the way Shopify's own form post reads them: every enabled
 * `properties[...]` field, keyed by the name inside the brackets. Blank values are dropped so a line never carries
 * an empty property. Files are skipped: apps such as Easify Product Options upload them and put the link in a property.
 */
export function formProperties(form) {
  const properties = {};
  if (!form) return properties;

  for (const [name, value] of new FormData(form)) {
    const key = name.match(PROPERTY_NAME)?.[1];
    if (key && typeof value === 'string' && value !== '') {
      properties[key] = value;
    }
  }

  return properties;
}
